import Model from './Model'

export default class Mailtag extends Model {
    resource() {
        return 'mailtag'
    }

    categories()
    {
        return this.hasMany(categories)
    }

    get active_leads()
    {
        return this.activeleads
    }

    get active_categories()
    {
        return this.activecategories
    }
}
